<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form :model="table.where" label-width="77px" class="ele-form-search"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">

                    <el-col :md="6" :sm="12">
                        <el-form-item label="模板名称:">
                            <el-input v-model="table.where.title" placeholder="请输入模板名称" clearable />
                        </el-form-item>
                    </el-col>
                    <el-col :md="6" :sm="12">
                        <div class="ele-form-actions">
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->
            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:storegoodsfare:add')">添加
                </el-button>
                <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:storegoodsfare:dall')">批量删除
                </el-button>
            </div>
            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row>
                <template slot-scope="{index}">

                    <el-table-column type="selection" width="45" align="center" fixed="left" />

                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />

                    <el-table-column prop="title" label="模板名称" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="method" label="计价方式" show-overflow-tooltip min-width="120">
                        <template slot-scope="{row}">
                            <div v-if="row.method==1">按重量</div>
                            <div v-if="row.method==2">按件数</div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="first_weight" label="首重/件" show-overflow-tooltip min-width="120">
                        <template slot-scope="{row}">
                            <div v-if="row.method==1">{{row.first_weight}}(kg)</div>
                            <div v-if="row.method==2">{{row.first_weight}}(件)</div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="first_price" label="首费" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="renew_weight" label="续重/件" show-overflow-tooltip min-width="120">
                        <template slot-scope="{row}">
                            <div v-if="row.method==1">{{row.renew_weight}}(kg)</div>
                            <div v-if="row.method==2">{{row.renew_weight}}(件)</div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="renew_price" label="续费（元）" show-overflow-tooltip min-width="120" />

                    <el-table-column label="添加时间" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:storegoodsfare:edit')">修改</el-link>
                            <el-popconfirm title="确定要删除此运费设置吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:storegoodsfare:delete')">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改运费设置':'添加运费设置'" :visible.sync="showEdit" width="80%" @closed="editForm={}"
            :destroy-on-close="true" :lock-scroll="false">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="120px">

                <el-form-item label="模板名称：" prop="title">
                    <el-input v-model="editForm.title" placeholder="请输入模板名称" clearable />
                </el-form-item>

                <el-form-item label="计价方式：" prop="method">
                    <el-radio-group v-model="editForm.method">
                        <el-radio :label="1">按重量计算</el-radio>
                        <el-radio :label="2">按商品件数计算</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item :label="editForm.method==1?'首重(kg)：':'首件(件)：'" prop="first_weight">
                    <el-input v-model="editForm.first_weight" :placeholder="editForm.method==1?'请输入首重(kg)：':'请输入首件(件)：'"
                        clearable />
                </el-form-item>

                <el-form-item label="首费(元)：" prop="first_price">
                    <el-input-number v-model="editForm.first_price" controls-position="right" :min="0"
                        placeholder="请输入首费(元)" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item :label="editForm.method==1?'续重(kg)：':'续件(件)：'" prop="renew_weight">
                    <el-input v-model="editForm.renew_weight" :placeholder="editForm.method==1?'请输入续重(kg)：':'请输入续件(件)：'"
                        clearable />
                </el-form-item>

                <el-form-item label="续费(元)：" prop="renew_price">
                    <el-input-number v-model="editForm.renew_price" controls-position="right" :min="0"
                        placeholder="请输入续费(元)" class="ele-fluid ele-text-left" />
                </el-form-item>
                <el-form-item label="目的地：">
                    <el-select v-model="province_value" placeholder="省" @change="provinceChange">
                        <el-option v-for="(item,index) in province_data" :key="index" :label="item.label"
                            :value="index">
                        </el-option>
                    </el-select>
                    <el-select v-model="city_value" placeholder="市" @change="cityChange">
                        <el-option v-for="(item,index) in city_data" :key="index" :label="item.label" :value="index">
                        </el-option>
                    </el-select>
                    <el-select v-model="area_value" placeholder="区">
                        <el-option v-for="(item,index) in area_data" :key="index" :label="item.label" :value="index">
                        </el-option>
                    </el-select>
                    <el-button type="text" @click="addCity">添加</el-button>
                </el-form-item>
                <el-form-item>
                    <el-tag v-for="(tag,index) in select_address" :key="index" closable @close="closeAddress(index)">
                        {{tag.province}} {{tag.city}} {{tag.area}}
                    </el-tag>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="showEdit=false">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import cityDataAll from '@/utils/cityData'
    import {
        mapGetters
    } from "vuex";
    export default {
        name: "SysStoreGoodsFare",
        data() {
            return {
                select_address: [],
                province_data: [],
                city_data: [],
                area_data: [],
                province_value: '',
                city_value: '',
                area_value: '',
                table: {
                    url: '/storegoodsfare/index',
                    where: {}
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    method: 1
                }, // 表单数据
                editRules: { // 表单验证规则

                    title: [{
                        required: true,
                        message: '请输入模板名称',
                        trigger: 'blur'
                    }],

                    method: [{
                        required: true,
                        message: '请输入费用计算方式，按重量计算，按商品件数计算',
                        trigger: 'blur'
                    }],

                    first_weight: [{
                        required: true,
                        message: '请输入首重',
                        trigger: 'blur'
                    }],

                    first_price: [{
                        required: true,
                        message: '请输入首费',
                        trigger: 'blur'
                    }],

                    renew_weight: [{
                        required: true,
                        message: '请输入续重',
                        trigger: 'blur'
                    }],

                    renew_price: [{
                        required: true,
                        message: '请输入续费（元）',
                        trigger: 'blur'
                    }],

                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        mounted() {
            this.province_data = JSON.parse(JSON.stringify(cityDataAll.cityData));
            var data = {
                label: '全部',
                value: '全部'
            }
            this.province_data.unshift(data)
        },
        methods: {
            closeAddress(e) {
                this.select_address.splice(e, 1);
            },
            provinceChange(e) {
                if (e != 0) {
                    this.city_data = JSON.parse(JSON.stringify(this.province_data[e].children));
                    var data = {
                        label: '全部',
                        value: '全部'
                    }
                    this.city_data.unshift(data)
                    this.area_data = [];
                    this.city_value = '';
                    this.area_value = '';
                } else {
                    this.city_data = [];
                    this.area_data = [];
                    this.city_value = '';
                    this.area_value = '';
                }
            },
            cityChange(e) {
                if (e != 0) {
                    this.area_data = JSON.parse(JSON.stringify(this.city_data[e].children));
                    var data = {
                        label: '全部',
                        value: '全部'
                    }
                    this.area_data.unshift(data)
                } else {
                    this.area_data = [];
                    this.area_value = '';
                }
            },
            addCity() {
                if (this.province_value === '') {
                    return false;
                }
                var province = '';
                var city = '';
                var area = '';
                if (this.province_value === 0) {
                    province = '全部';
                } else {
                    province = this.province_data[this.province_value].label;
                    if (this.city_value != '') {
                        if (this.city_value === 0) {
                            city = '全部';
                        } else {
                            city = this.city_data[this.city_value].label;
                            if (this.area_value != '') {
                                if (this.area_value === 0) {
                                    area = '全部';
                                } else {
                                    area = this.area_data[this.area_value].label;
                                }
                            }

                        }
                    }

                }
                var temp_info = {
                    province: province,
                    city: city,
                    area: area
                }
                this.select_address.push(temp_info);
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/storegoodsfare/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.editForm = res.data.data;
                        this.select_address = [];
                        this.select_address = res.data.data.select_address;
                        this.showEdit = true;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.editForm.select_address = JSON.stringify(this.select_address);
                        this.$http.post('/storegoodsfare/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的运费设置吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/storegoodsfare/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/storegoodsfare/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>